import { ConstructorTabs } from "../../../components/admin-console/constructor-tabs";
import { MOCK_CONSTRUCTOR_SERVICES } from "../constructor-services-page.lib";

/** Табы «Конструктор — Услуги / Дороги / Документы» со счётчиком услуг. */
export const ConstructorServicesTabs = () => <ConstructorTabs servicesCount={MOCK_CONSTRUCTOR_SERVICES.length} />;
